var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { singleton } from "tsyringe";
import { makeImmutable } from "../core";
import { RestaumaticRPCService } from "./RestaumaticRPCService";
/**
 * Service for phone number validation
 */
let ValidatePhoneNumberService = class ValidatePhoneNumberService {
    constructor(rpcService) {
        this.rpcService = rpcService;
        makeImmutable(this);
    }
    /**
     * @returns is the provided phone number valid?
     */
    async validatePhoneNumber(value, country) {
        return await this.rpcService.rpc("ValidatePhoneNumberRequest", {
            country,
            phone: value,
        });
    }
};
ValidatePhoneNumberService = __decorate([
    singleton(),
    __metadata("design:paramtypes", [typeof (_a = typeof RestaumaticRPCService !== "undefined" && RestaumaticRPCService) === "function" ? _a : Object])
], ValidatePhoneNumberService);
export { ValidatePhoneNumberService };
